import { ChapterLinkCollection, HeadingLink } from './chapter.types';

// Type guard function
export function isStringArray(collection: ChapterLinkCollection): collection is string[] {
  return (collection as HeadingLink[])[0].Href === undefined;
}
